import { z } from 'zod';

export const clientFormSchema = z.object({
  name: z.string().min(1, 'Name is required.'),
  status: z.enum(['active', 'inactive']),
});

export type ClientFormValues = z.infer<typeof clientFormSchema>;
